import React from 'react';
import cn from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import { If } from 'utils';
import { ReactComponent as CheckIcon } from 'images/icons/select-check.svg';

export default function Checkbox({
  title = '',
  checked = false,
  toggle = () => {},
  disabled = false,
  className = '',
  wrapperClassName = '',
  textClassName = '',
  children = null
}) {
  const uniqueId = uuidv4();
  const wrapClass = cn('uiKit__element', 'uiKit__checkboxWrapper', {
    [wrapperClassName]: !!wrapperClassName
  });
  const textClass = cn('selection-title', {
    [textClassName]: !!textClassName
  });
  return (
    <div className={wrapClass}>
      <div className="uiKit__checkbox">
        <input
          id={uniqueId}
          type="checkbox"
          checked={checked}
          onChange={() => toggle(!checked)}
          disabled={disabled}
        />
        <label htmlFor={uniqueId} className={className}>
          {checked && <CheckIcon />}
        </label>
        <If test={title && typeof title === 'string'}>
          <label htmlFor={uniqueId} className={textClass}>
            {title}
          </label>
        </If>
      </div>
      <If test={children}>{children}</If>
    </div>
  );
}
